<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item">
      <h3 class="heading-underline">Run a Kyloe AwesomeDoc against all {{ entityMap[primaryEntity] }} records found</h3>
      <form [formGroup]="actionForm">
        <mat-select
          class="full-width"
          [placeholder]="configPlaceholder()"
          [formControl]="configControl"
          required>
          <mat-option *ngFor="let config of configs" [value]="config.id" (onSelectionChange)="updateDocusignEnabled($event)">{{config.name}}</mat-option>
        </mat-select>
        <div class="message tip" *ngIf="docusignEnabled">
          <i class="bhi-info"></i> This AwesomeDocs template is e-signature enabled. Generated files will be sent for signature.
        </div>
        <app-action-warning-block
          [message]="warningMessage"
          [actionType]="dataRulesService.actionOpName(dataRulesService.actionOperators.INSERT)"
        ></app-action-warning-block>
        <div class="message tip">
          <i class="bhi-info"></i> Will create new {{ entityMap[primaryEntity] }} file attachments associated with {{ entityMap[primaryEntity] }} records that match your criteria.
        </div>
      </form>
    </li>
  </ul>
</section>
